import Chart from 'react-apexcharts'

const StackedColumnChart = ({ chartId, xaxis, earlyAdmitArray, regularAdmitArray }) => {
  const filterDataWithCategories = (
    arrays: number[][],
    categories: string[]
  ): {
    filteredArrays: number[][],
    filteredCategories: string[]
  } => {
    const length = arrays[0]?.length || 0;
    const filteredArrays: number[][] = arrays.map(() => []);
    const filteredCategories: string[] = [];

    for (let i = 0; i < length; i++) {
      const valuesAtIndex = arrays.map((arr) => arr[i]);
      const hasValidValue = valuesAtIndex.some(
        (val) => val != null && val !== 0
      );

      if (hasValidValue) {
        valuesAtIndex.forEach((val, idx) => {
          filteredArrays[idx].push(val);
        });
        filteredCategories.push(categories[i]);
      }
    }

    return { filteredArrays, filteredCategories };
  };

  const {
    filteredArrays: [filteredEarlyAdmits, filteredRegularAdmits],
    filteredCategories: filteredXAxis
  } = filterDataWithCategories(
    [earlyAdmitArray, regularAdmitArray],
    xaxis
  );

  return (
    <Chart
      options={{
        chart: {
          id: chartId,
          stacked: true,
          stackType: '100%',
          toolbar: { show: false },
        },
        xaxis: {
          categories: filteredXAxis,
          labels: {
            show: true,
            rotate: -45,
          }
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            style: { colors: ['#9AA2B6'] },
            formatter: (val) => val.toFixed(0) + '%'
          }
        },
        colors: ['#FFEF68', '#97E6FF'],
        tooltip: { enabled: false },
        legend: {
          show: true,
          onItemClick: { toggleDataSeries: false },
          onItemHover: { highlightDataSeries: true },
        },
        dataLabels: {
          enabled: true,
          style: { colors: ['#000000'] },
          background: {
            enabled: false,
            borderWidth: 0,
            foreColor: '#000',
          },
          formatter: (val) => {
            if (typeof val === 'number') {
              return val.toFixed(1) + '%';
            }
            const parsed = parseFloat(String(val));
            return !isNaN(parsed) ? parsed.toFixed(1) + '%' : 'N/A';
          }

        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            dataLabels: {
              position: 'top',
            },
          }
        }
      }}
      series={[
        {
          name: 'Early Round Admits',
          group: 'Admits',
          data: filteredEarlyAdmits
        },
        {
          name: 'Regular Round Admits',
          group: 'Admits',
          data: filteredRegularAdmits
        },
      ]}
      type='bar'
      height={'300'}
    />
  );
};

// const StackedColumnChart = ({ chartId, xaxis, earlyAdmitArray, regularAdmitArray }) => {

//   return (
//     <Chart
//       options={{
//         chart: {
//           id: chartId,
//           stacked: true,
//           stackType: '100%',
//           toolbar: {
//             show: false,
//           },
//         },
//         xaxis: {
//           categories: xaxis,
//           labels: {
//             show: true,
//             rotate: -45,
//           }
//         },
//         yaxis: {
//           min: 0,
//           max: 100,
//           labels: {
//             style: {
//               colors: ['#9AA2B6'],
//             },
//             formatter: function (val) {
//               return val.toFixed(0) + "%";
//             }
//           }
//         },
//         //colors: ['#98F29B', '#008FFB'],
//         colors: ["#FFEF68", "#97E6FF"],
//         tooltip: {
//           enabled: false,
//         },
//         legend: {
//           show: true,
//           onItemClick: {
//             toggleDataSeries: false
//           },
//           onItemHover: {
//             highlightDataSeries: true
//           },
//         },
//         dataLabels: {
//           enabled: true,
//           style: {
//             colors: ['#000000'],
//           },
//           background: {
//             enabled: false,
//             borderWidth: 0,
//             foreColor: '#000',
//           },
//           formatter: function (val: number, opts) {
//             return val.toFixed(1) + "%";
//           },

//         },
//         plotOptions: {
//           bar: {
//             horizontal: false,
//             columnWidth: '55%',
//             dataLabels: {
//               position: 'top',
//             },
//           }
//         }
//       }}
//       series={[
//         {
//           name: 'Early Round Admits',
//           group: 'Admits',
//           data: earlyAdmitArray
//         },
//         {
//           name: 'Regular Round Admits',
//           group: 'Admits',
//           data: regularAdmitArray
//         },
//       ]}
//       type='bar'
//       height={'300'}
//     />
//   )
// }

const StackedColumnChartGender = ({
  chartId,
  xaxis,
  menAdmittedArray,
  womenAdmittedArray,
  otherAdmittedArray,
  menEnrolledArray,
  womenEnrolledArray,
  otherEnrolledArray,
}) => {
  const filterDataWithCategories = (
    arrays: number[][],
    categories: string[]
  ): {
    filteredArrays: number[][],
    filteredCategories: string[]
  } => {
    const length = arrays[0]?.length || 0;
    const filteredArrays: number[][] = arrays.map(() => []);
    const filteredCategories: string[] = [];

    for (let i = 0; i < length; i++) {
      const valuesAtIndex = arrays.map((arr) => arr[i]);
      const hasValidValue = valuesAtIndex.some(
        (val) => val != null && val !== 0
      );

      if (hasValidValue) {
        valuesAtIndex.forEach((val, idx) => {
          filteredArrays[idx].push(val);
        });
        filteredCategories.push(categories[i]);
      }
    }

    return { filteredArrays, filteredCategories };
  };

  const allArrays = [
    menAdmittedArray,
    womenAdmittedArray,
    otherAdmittedArray,
    menEnrolledArray,
    womenEnrolledArray,
    otherEnrolledArray,
  ];

  const {
    filteredArrays: [
      filteredMenAdmitted,
      filteredWomenAdmitted,
      filteredOtherAdmitted,
      filteredMenEnrolled,
      filteredWomenEnrolled,
      filteredOtherEnrolled,
    ],
    filteredCategories: filteredXAxis,
  } = filterDataWithCategories(allArrays, xaxis);

  const includeOther = filteredOtherAdmitted.some(val => val != null && val !== 0)
    && filteredOtherEnrolled.some(val => val != null && val !== 0);

  const series = includeOther
    ? [
      { name: 'Men Admits', group: 'Admits', data: filteredMenAdmitted },
      { name: 'Women Admits', group: 'Admits', data: filteredWomenAdmitted },
      { name: 'Other Admits', group: 'Admits', data: filteredOtherAdmitted },
      { name: 'Men Enrolled', group: 'Enrolled', data: filteredMenEnrolled },
      { name: 'Women Enrolled', group: 'Enrolled', data: filteredWomenEnrolled },
      { name: 'Other Enrolled', group: 'Enrolled', data: filteredOtherEnrolled },
    ]
    : [
      { name: 'Men Admits', group: 'Admits', data: filteredMenAdmitted },
      { name: 'Women Admits', group: 'Admits', data: filteredWomenAdmitted },
      { name: 'Men Enrolled', group: 'Enrolled', data: filteredMenEnrolled },
      { name: 'Women Enrolled', group: 'Enrolled', data: filteredWomenEnrolled },
    ];

  return (
    <Chart
      options={{
        chart: {
          id: chartId,
          stacked: true,
          stackType: 'normal',
          toolbar: { show: false },
        },
        xaxis: {
          categories: filteredXAxis,
          labels: {
            show: true,
            rotate: -45,
            style: { colors: '#9AA2B6' },
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          labels: {
            style: { colors: ['#9AA2B6'] },
            formatter: (val) => `${Number(val).toFixed(0)}%`,
          },
        },
        colors: ['#90F892', '#FFEF68', '#C5DEF9', '#00E986', '#97E6FF', '#767676'],
        tooltip: { enabled: true },
        legend: {
          show: true,
          onItemClick: { toggleDataSeries: false },
          onItemHover: { highlightDataSeries: true },
        },
        dataLabels: {
          enabled: true,
          style: { colors: ['#000000'] },
          background: {
            enabled: false,
            borderWidth: 0,
            foreColor: '#000',
          },
          formatter: (val) =>
            val != null && val !== 0 ? `${Number(val).toFixed(1)}%` : '',
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '75%',
            dataLabels: {
              position: 'top',
            },
          },
        },
      }}
      series={series}
      type="bar"
      height="300"
    />
  );
};

// const StackedColumnChartGender = ({ chartId, xaxis, menAdmittedArray, womenAdmittedArray, otherAdmittedArray, menEnrolledArray, womenEnrolledArray, otherEnrolledArray }) => {
//   return (
//     <Chart
//       options={{
//         chart: {
//           id: chartId,
//           stacked: true,
//           stackType: 'normal',
//           toolbar: {
//             show: false,
//           },
//         },
//         xaxis: {
//           categories: xaxis,
//           labels: {
//             show: true,
//             rotate: -45,
//           }
//         },
//         yaxis: {
//           min: 0,
//           max: 100,
//           labels: {
//             style: {
//               colors: ['#9AA2B6'],
//             },
//             formatter: function (val) {
//               return val.toFixed(0) + "%";
//             }
//           }
//         },
//         //colors: ['#98F29B', '#008FFB'],
//         //colors: ["#FFEF68", "#97E6FF"],
//         colors: ["#90F892", "#FFEF68", "#C5DEF9", "#00E986", "#97E6FF", "767676"],
//         tooltip: {
//           enabled: true,
//         },
//         legend: {
//           show: true,
//           onItemClick: {
//             toggleDataSeries: false
//           },
//           onItemHover: {
//             highlightDataSeries: true
//           },
//         },
//         dataLabels: {
//           enabled: true,
//           style: {
//             colors: ['#000000'],
//           },
//           background: {
//             enabled: false,
//             borderWidth: 0,
//             foreColor: '#000',
//           },
//           formatter: function (val: number, opts) {
//             return val ? val.toFixed(1) + "%" : ''
//           },

//         },
//         plotOptions: {
//           bar: {
//             horizontal: false,
//             columnWidth: '75%',
//             dataLabels: {
//               position: 'top',
//             },
//           }
//         }
//       }}
//       series={otherAdmittedArray.some(item => item != 0 && item != null) && otherEnrolledArray.some(item => item != 0 && item != null) ? [
//         {
//           name: 'Men Admits',
//           group: 'Admits',
//           data: menAdmittedArray
//         },
//         {
//           name: 'Women Admits',
//           group: 'Admits',
//           data: womenAdmittedArray
//         },
//         {
//           name: 'Other Admits',
//           group: 'Admits',
//           data: otherAdmittedArray
//         },
//         {
//           name: 'Men Enrolled',
//           group: 'Enrolled',
//           data: menEnrolledArray
//         },
//         {
//           name: 'Women Enrolled',
//           group: 'Enrolled',
//           data: womenEnrolledArray
//         },
//         {
//           name: 'Other Enrolled',
//           group: 'Enrolled',
//           data: otherEnrolledArray
//         }
//       ] : [
//         {
//           name: 'Men Admits',
//           group: 'Admits',
//           data: menAdmittedArray
//         },
//         {
//           name: 'Women Admits',
//           group: 'Admits',
//           data: womenAdmittedArray
//         },
//         {
//           name: 'Men Enrolled',
//           group: 'Enrolled',
//           data: menEnrolledArray
//         },
//         {
//           name: 'Women Enrolled',
//           group: 'Enrolled',
//           data: womenEnrolledArray
//         }
//       ]}
//       type='bar'
//       height={'300'}
//     />
//   )
// }

export {
  StackedColumnChart,
  StackedColumnChartGender
}
